import {TableColumn} from '@fl/cmsch-fe-library';

import {UsersTableType} from '../../types/users-table-type';

/** Columns for the admin users table. */
export const usersColumns: Array<TableColumn<UsersTableType>> = [
    {
        field: 'active',
        type: 'boolean',
    },
    {
        field: 'firstName',
        type: 'string',
        customFiltersOnly: true,
        filterTypes: ['containsString', 'null'],
    },
    {
        field: 'lastName',
        type: 'string',
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    },
    {
        field: 'registrationEmail',
        type: 'string',
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    },
    {
        field: 'aaGuid',
        type: 'string',
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    },
    {
        field: 'username',
        type: 'string',
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}],
    },
];
